module.exports = __webpack_public_path__ + "img/homeLogo.d14cb1fe.png";